/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationRequest extends models.AppSecopsApplicationBase {
    getFixupPrototypeFunction() { return AppSecopsApplicationRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationRequest>): AppSecopsApplicationRequest {
        let obj = Object.assign(new AppSecopsApplicationRequest(), model);
        AppSecopsApplicationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationRequest>): AppSecopsApplicationRequest {
        if (!model) return null;
        return AppSecopsApplicationRequest.newInstance(<AppSecopsApplicationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationRequest) {
        if (!obj) return;

        models.AppSecopsApplicationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationRequest): boolean {
        if (models.AppSecopsApplicationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
